export default "__VITE_ASSET__D9ZJi3dy__"